import WidgetForm from "./WidgetForm";
import {useService} from "../../../../../base/hooks/useService";
import DynamicWidgetsService from "../../../../../services/DynamicWidgetsService";
import {useLoading} from "../../../../../base/hooks/useLoading";
import {Formik} from "formik";
import {ModalFooter} from "reactstrap";
import Button from "../../../../../base/components/Button";
import {BUTTON_COLORS} from "../../../../../base/components/Button/appearance";
import React from "react";
import {initialValues, validationSchema} from "./form";
import {CustomModal, ModalBody, ModalHeader} from "../../../../../base/components/CustomModal";
import ToasterService from "../../../../../services/ToastService";
import useUploadImages from "../../../../../base/components/Dropzone/useUploadImages";
import {DYNAMIC_WIDGET_FILE_TYPE} from "../../../../../base/constants/shared";

const CreateWidgetModal = ({isOpen, onClose, afterCreate}) => {
    /**
     * @type {DynamicWidgetsService}
     */
    const widgetsService = useService(DynamicWidgetsService);
    /**
     * @type {ToasterService}
     */
    const toastService = useService(ToasterService);

    const [isLoading, {registerPromise}] = useLoading(false);
    const uploadImage = useUploadImages();

    const createWidget = (values, formikHelpers) => {
        formikHelpers.setSubmitting(true);
        const {label, unit, icon, placeholderIcon} = values;
        registerPromise(Promise.all([
            uploadImage(icon[0].file, DYNAMIC_WIDGET_FILE_TYPE),
            uploadImage(placeholderIcon[0].file, DYNAMIC_WIDGET_FILE_TYPE)
        ]))
        .then(([fileIcon, filePlaceholderIcon]) => {
            const widgetData = {
                label,
                unit,
                status: true,
                iconId: fileIcon.file.id,
                placeholderIconId: filePlaceholderIcon.file.id,
            }
            return registerPromise(widgetsService.postAdminsWidget(widgetData))
                .then(() => {
                    toastService.success('Widget has been successfully created')
                    onClose()
                })
                .finally(() => {
                    afterCreate()
                    formikHelpers.setSubmitting(false);
                })
        })
    }

    return (
        <CustomModal scrollable isOpen={isOpen} className="widget-modal fontStyles" size="md">
            <ModalHeader onClose={() => onClose()} className="font-weight-semibold text-dark">
                Create widget
            </ModalHeader>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnBlur
                onSubmit={(values, formikHelpers) => {
                    createWidget(values, formikHelpers)
                }}
                enableReinitialize
            >
                {({values, handleSubmit, isSubmitting, isValid, touched}) => {
                    return (
                        <>
                            <ModalBody className="p-3">
                                <WidgetForm values={values}/>
                            </ModalBody>
                            <ModalFooter>
                                <div className="d-flex justify-content-end gap-2">
                                    <Button
                                        color={BUTTON_COLORS.primaryOutline}
                                        type="button"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        color={BUTTON_COLORS.primary}
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && touched)}
                                        loading={isLoading}
                                        onClick={handleSubmit}
                                    >
                                        Create
                                    </Button>
                                </div>
                            </ModalFooter>
                        </>
                    )
                }}
            </Formik>
        </CustomModal>
    )
}

export default CreateWidgetModal;